module.exports = __webpack_public_path__ + "img/agence-06.1ee14cb.jpg";